module.exports = __webpack_public_path__ + "img/alert-triangle.e0e7b58b.svg";